import React from "react";
import { useSpring, animated } from '@react-spring/web';

function currentOrFutureDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const minDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    return minDate;
}

function currentOrPastDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const maxDate = `${year}-${month}-${day}`;
    return maxDate;
}

function Past18YearsDate() {
    const currentDate = new Date();
    const minYear = currentDate.getFullYear() - 18;
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const maxDate = `${minYear}-${month}-${day}`;
    return maxDate;
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}

const languages = [
    { name: "English", voice: "en-IN-NeerjaNeural", langCode: "en-IN" },
    { name: "Hindi", voice: "hi-IN-SwaraNeural", langCode: "hi-IN" },
    { name: "Bengali", voice: "bn-IN-BashkarNeural", langCode: "bn-IN" },
    { name: "Telugu", voice: "te-IN-ShrutiNeural", langCode: "te-IN" },
    { name: "Marathi", voice: "mr-IN-AarohiNeural", langCode: "mr-IN" },
    { name: "Tamil", voice: "ta-IN-PallaviNeural", langCode: "ta-IN" },
    { name: "Urdu", voice: "ur-IN-GulNeural", langCode: "ur-IN" },
    { name: "Gujarati", voice: "gu-IN-DhwaniNeural", langCode: "gu-IN" },
    { name: "Kannada", voice: "kn-IN-SamhitaNeural", langCode: "kn-IN" },
    // { name: "Odia", voice: "or-IN-SukantNeural", langCode: "or-IN" },
    { name: "Punjabi", voice: "pa-IN-OjasNeural", langCode: "pa-IN" },
    { name: "Malayalam", voice: "ml-IN-RasikaNeural", langCode: "ml-IN" }
];


function exportTableToCSV(filename, level, countData) {
    const rows = [
        [level, "Total", "Completed", 'Ongoing', 'Initiated', "Physical", "Digital"], // Header row
    ];

    // Collect the data from the countData object
    Object.entries(countData).forEach(([name, counts]) => {
        const row = [
            name,
            counts.totalCount || 0,
            counts.completedEvent || 0,
            counts.ongoingEvent || 0,
            counts.initiateEvent || 0,
            counts.physicalCount || 0,
            counts.digitalCount || 0,
        ];
        rows.push(row);
    });

    let csvContent = "data:text/csv;charset=utf-8,"
        + rows.map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
}

const DynamicCount = (value) => {
    const props = useSpring({
        number: value || 0,
        from: { number: 0 },
        config: { duration: 600 }, // Duration of the animation in ms
    });
    return (
        <animated.div>
            {props.number.to(n => Math.floor(n))}
        </animated.div>
    );
};

export default { currentOrFutureDate, currentOrPastDate, Past18YearsDate, formatDate, languages, exportTableToCSV, DynamicCount }